// material-ui
import { alpha, createTheme } from '@mui/material/styles';
import { PaletteMode } from '@mui/material';

// project-imports
import ThemeOption from './theme';
import { ThemeMode } from '@/config';

// types
import { PresetColor } from '@/types/base/config';
import { PaletteThemeProps } from '@/types/base/theme';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

export default function Palette(mode: ThemeMode, presetColor: PresetColor, themeContrast: boolean) {
  const paletteColor: PaletteThemeProps = ThemeOption(presetColor, mode);

  return createTheme({
    palette: {
      mode: mode as PaletteMode,
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      text: {
        primary: mode === ThemeMode.DARK ? alpha(paletteColor.neutral.darker!, 0.87) : paletteColor.neutral[800],
        secondary: mode === ThemeMode.DARK ? alpha(paletteColor.neutral.darker!, 0.45) : paletteColor.neutral.main,
        neutral: mode === ThemeMode.DARK ? alpha(paletteColor.neutral.darker!, 0.45) : paletteColor.neutral.main,
        error: mode === ThemeMode.DARK ? alpha(paletteColor.error.darker!, 0.1) : paletteColor.error.main,
        success: mode === ThemeMode.DARK ? alpha(paletteColor.success.darker!, 0.1) : paletteColor.success.main,
        info: mode === ThemeMode.DARK ? alpha(paletteColor.info.darker!, 0.1) : paletteColor.info.main,
        warning: mode === ThemeMode.DARK ? alpha(paletteColor.warning.darker!, 0.1) : paletteColor.warning.main,
        disabled: mode === ThemeMode.DARK ? alpha(paletteColor.disabled.darker!, 0.1) : paletteColor.disabled.main
        // disabled: mode === ThemeMode.DARK ? alpha(paletteColor.neutral.darker!, 0.1) : paletteColor.neutral[400]
      },
      action: {
        disabled: paletteColor.neutral.light
      },
      divider: mode === ThemeMode.DARK ? alpha(paletteColor.neutral.darker!, 0.05) : alpha(paletteColor.neutral.light!, 0.65),
      background: {
        paper: mode === ThemeMode.DARK ? paletteColor.neutral[100] : '#fff',
        default: themeContrast && mode !== ThemeMode.DARK ? '#fff' : paletteColor.neutral.lighter
      }
    }
  });
}
